import React from 'react';

const HomeLayout = ({ children }) => {
  return <div>{children}</div>;
};

export default HomeLayout;
